import { useEffect, useState, useCallback, createContext, useContext } from 'react';
import { routes } from '../../options/routes';

// Helpers
import { getClubPlayersList } from '../../utils/helpers/getClubPlayersList';
import
{
  loggedInPlayerInChoicesById,
} from '../../utils/helpers/playerChoicesHelpers';
import
{
  getNewPlayerStats,
} from '../../utils/helpers/indexStatsHelpers';

// API calls
import
{
  getClubPlayers,
  getBoardsRezzilIndex,
  getGlobalLeaderBoardStats,
} from '../../api';

// Contexts
import { BaseContext } from '../Global/BaseProvider';

import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const IndexStatsContext = createContext({});
const IndexStatsProvider = ({ children }) =>
{
  const params = useParams();
  const baseContext = useContext(BaseContext);
  const [indexStatsData, setIndexStatsData] = useState({});

  const getProfileIdsFromParams = ((params) =>
  {
    let profileIds = [];
    if (params.profileId)
    {
      profileIds.push(params.profileId);
    }
    if (params.secondProfileId)
    {
      profileIds.push(params.secondProfileId);
    }
    return profileIds;
  });


  const getIndexStatsData = useCallback(async () =>
  {
    // Only trigger API call for indexStats route
    const activeRoute = window.location.pathname;
    if (activeRoute.indexOf(routes.indexStats) !== 0) return;

    // Call API
    if (!baseContext.baseData.loading && !indexStatsData.loading)
    {
      setIndexStatsData({ loading: true });
      // Set score variables
      let playerProfiles = null,
        allProgrammeSessions = null,
        allProgrammeSessionsDeep = null,
        playerStats = null,
        worldAvgStats = null,
        programmeSessionStats = null,
        indexBreakdownData = null;
      const { userProfile, clubProfile, profiles } = baseContext.baseData;
      const { id } = clubProfile;
      const clubRezzilIndexData = await getBoardsRezzilIndex(id);
      const globalRezzilIndexData = await getGlobalLeaderBoardStats();
      // Call club player profiles API

      // Get playerProfiles from playerProfilesData

      playerProfiles = getClubPlayersList(profiles);

      const clubLeaderboard = clubRezzilIndexData.data.leaderboard.scores;
      const globalLeaderboard = globalRezzilIndexData.data.leaderboards.rezzil_index.scores;

      // Get logged in player stats if in playerProfiles
      const { id: loggedInPlayerId } = userProfile;
      const hasLoggedInPlayerInChoicesById = loggedInPlayerInChoicesById(loggedInPlayerId, playerProfiles);

      let profileIds = getProfileIdsFromParams(params);
      if (profileIds.length === 0)
      {
        const selectedProfileIds = localStorage.getItem('selectedProfileIds');
        if (selectedProfileIds)
        {
          profileIds = JSON.parse(selectedProfileIds);
        } else
        {
          if (hasLoggedInPlayerInChoicesById)
          {
            profileIds = [loggedInPlayerId]
          } else
          {
            profileIds = [playerProfiles[0]?.id];
          }
        }

      }
      const initialPlayerId = profileIds[0];
      // if (loggedInPlayerInChoicesById(loggedInPlayerId, playerProfiles)) {
      // Make relevant API calls to get data

      if (!initialPlayerId)
      {
        // const generalWorldAvgStats = await getWorldAverageStatsForNoPlayers();
        setIndexStatsData({
          loading: false,
          playerProfiles,
          allProgrammeSessions,
          allProgrammeSessionsDeep,
          playerStats,
          worldAvgStats: {},
          programmeSessionStats,
          indexBreakdownData,
          clubLeaderboard,
          globalLeaderboard,
          apiError: false,
          allLoaded: true,
        });
        return;
      }
      const { success, newPlayerStats } = await getNewPlayerStats(initialPlayerId, clubLeaderboard, globalLeaderboard);

      if (!success)
      {
        setIndexStatsData({
          loading: false,
          playerProfiles,
          allProgrammeSessions,
          allProgrammeSessionsDeep,
          playerStats,
          worldAvgStats,
          programmeSessionStats,
          indexBreakdownData,
          apiError: true,
          allLoaded: true,
        });
        return;
      }

      allProgrammeSessions = newPlayerStats.allProgrammeSessions;
      allProgrammeSessionsDeep = newPlayerStats.allProgrammeSessionsDeep;
      playerStats = newPlayerStats.playerStats;
      worldAvgStats = newPlayerStats.worldAvgStats;
      programmeSessionStats = newPlayerStats.programmeSessionStats;
      indexBreakdownData = newPlayerStats.indexBreakdownData;

      setIndexStatsData({
        loading: false,
        playerProfiles,
        allProgrammeSessions,
        allProgrammeSessionsDeep,
        playerStats,
        worldAvgStats,
        programmeSessionStats,
        indexBreakdownData,
        clubLeaderboard,
        globalLeaderboard,
        apiError: false,
        allLoaded: true,
      });
    }
  }, [baseContext]);

  useEffect(() =>
  {
    getIndexStatsData();
  }, [getIndexStatsData]);

  return (
    <IndexStatsContext.Provider
      value={{
        indexStatsData,
        getIndexStatsData
      }}
    >
      {children}
    </IndexStatsContext.Provider>
  );
}

export { IndexStatsProvider, IndexStatsContext };

export default IndexStatsProvider;
